<template>
  <div class="Challenge">
    <div id="form-div">
      <div class="row justify-content-center align-items-center">
        <div class="col-md-10">
          {{ $t('wheelAnalysis.keywordView.prompt') }}
        </div>
      </div>

      <div class="row justify-content-center align-items-center">
        <div class="col-md-10">
          <div class="col-md-12" style="float:left">
            <MDBInput
                :disabled="!editMode"
                :label="$t('wheelAnalysis.keywordView.keyword1Label')"
                v-model="keyword1"
                @change="keywordStore.keyword1Changed()"
            />
          </div>

          <br />
          <br />

          <div class="col-md-12" style="float:left">
            <MDBInput
                :disabled="!editMode"
                :label="$t('wheelAnalysis.keywordView.keyword2Label')"
                v-model="keyword2"
                @change="keywordStore.keyword2Changed()"
            />
          </div>

          <br />
          <br />

          <div class="col-md-12" style="float:left">
            <MDBInput
                :disabled="!editMode"
                :label="$t('wheelAnalysis.keywordView.keyword3Label')"
                v-model="keyword3"
                @change="keywordStore.keyword3Changed()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <router-view />
</template>

<script src="./_KeywordView.js" lang="js"></script>
<style src="./_KeywordView.less" lang="less" scoped></style>
